import {stringifyId} from '../../../../../types'
import type {
  BuildId,
  VcsRootId,
  NormalizedVcsRootInstance,
  VcsRootInstanceId,
  VcsRoot,
} from '../../../../../types'
import type {KeyValue} from '../../../../../utils/object'

export const sortByVcsRootName =
  (
    vcsRootInstances: KeyValue<VcsRootInstanceId, NormalizedVcsRootInstance>,
    vcsRoots: KeyValue<VcsRootId, VcsRoot>,
  ) =>
  (firstVcsId: VcsRootInstanceId, secondVcsId: VcsRootInstanceId): number => {
    const firstVcsRootId = vcsRootInstances[firstVcsId]?.['vcs-root']
    const secondVcsRootId = vcsRootInstances[secondVcsId]?.['vcs-root']

    const firstVcsRootName = firstVcsRootId != null ? (vcsRoots[firstVcsRootId]?.name ?? '') : ''
    const secondVcsRootName = secondVcsRootId != null ? (vcsRoots[secondVcsRootId]?.name ?? '') : ''

    if (firstVcsRootName > secondVcsRootName) {
      return 1
    }

    if (firstVcsRootName < secondVcsRootName) {
      return -1
    }

    return 0
  }

export const getCurrentBuildRevisionsLocator = (buildId: BuildId | null | undefined): string =>
  `id:${stringifyId(buildId)}`

export const getDependencyBuildRevisionsLocator = (buildId: BuildId | null | undefined): string =>
  `defaultFilter:false,snapshotDependency(to:(id:${stringifyId(buildId)})),count:1000`
